import { api } from './api.js';

export const dashboardAPI = {
  list: async (params = {}) => {
    const response = await api.get('/dashboard/list', { params });
    return response.data;
  },

  getStats: async (params = {}) => {
    const response = await api.get('/dashboard/stats', { params });
    return response.data;
  }
}